// Functions to import various components from the CDN

function appendCacheBusting(url) {
  let date = new Date();
  let oneHourCache = date.getMonth()+1+""+date.getDate()+""+date.getFullYear()+""+date.getHours();
  return `${url}?v=${oneHourCache}`;
}
function appendOneDayCacheBusting(url) {
  let date = new Date();
  let oneDayCache = date.getMonth()+1+""+date.getDate()+""+date.getFullYear();
  return `${url}?v=${oneDayCache}`;
}
export function safeImportComponent(componentURL, bustCache = true) {
  let isScript = componentURL.includes(".js");
  let isStyling = componentURL.includes(".css");

  if (!isScript && !isStyling) {
    console.error(`Component type not recognized for file: ${componentURL}`);
    return;
  }

  var headElement = document.getElementsByTagName("head")[0];
  if (document.getElementById(componentURL)) {
    // This component has already been pulled
    return;
  }

  let cacheBustedURL = componentURL;
  if (bustCache) {
    cacheBustedURL = appendCacheBusting(componentURL);
  }

  var newElement = null;
  if (isScript) {
    if (bustCache) {
      cacheBustedURL = appendCacheBusting(componentURL);
    }
    newElement = document.createElement("script");
    newElement.src = cacheBustedURL;
    newElement.defer = true;
  } else if (isStyling) {

    newElement = document.createElement("link");
    newElement.type = "text/css";
    newElement.rel = "stylesheet";
    if (bustCache) {
      cacheBustedURL = appendOneDayCacheBusting(componentURL);
    }
    newElement.href = cacheBustedURL;
  }
  // ID is without cache busting
  newElement.id = componentURL;

  headElement.appendChild(newElement);
}

export function renamePlatformCategory(platformCategory) {
  return platformCategory === "HR" ? "AskHR" : platformCategory;
}



// WEBPACK FOOTER //
// ./src/utils/componentImportUtils.js